export default __webpack_public_path__ + "static/media/flag-tr.14385506.svg";